module.exports = __webpack_public_path__ + "upload-cloud.png?ce73578a5166a8f218fd1eaaa5f2e1ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upload-cloud.png
// module id = 692
// module chunks = 0 2 7 8 9 10